import React from "react";
import { useSelector, useDispatch } from "react-redux";
import i18next from "i18next";
import { actions as surveyActions } from "../../../modules/survey";
import Welcome from "../../page/Welcome";
import MultilingualWelcome from "../../page/MultilingualWelcome";

const RenderGreetings = ({
  surveyId,
  previewing,
  singleLangPreview,
  currentLang,
  // welcomeDone,
  setWelcomeDone,
  selectedLanguage,
  setSelectedLanguage,
  campaignDetails
}) => {
  const dispatch = useDispatch();
  const {
    currentTheme,
    greetings,
    data: survey,
  } = useSelector((state) => state.survey);

  const handleGetStarted = () => {
    dispatch(
      surveyActions.surveyRequestTakerView(
        surveyId,
        previewing === true || previewing === "true" ? true : false,
        currentLang || selectedLanguage,
        true,
        campaignDetails
      )
    ).then((data) => {
      if (data && data.surveyExists && data.surveyExists !== false) {
        // commenting this because we do not have language dropdown now, static text is default to always english
        // i18next.changeLanguage(this.state.selectedLanguage); // changing page language on click of 'get started' button
        setWelcomeDone(true);
      }
    });
  };

  const chooseLanguage = (e) => {
    const lang = e.target.value;
    setSelectedLanguage(lang);
    if (lang === "es") {
      i18next.changeLanguage("es-MX");
    } else if (lang === "fr") {
      i18next.changeLanguage("fr");
    } else if (lang === "zh") {
      i18next.changeLanguage("zh");
    } else if (lang === "my") {
      i18next.changeLanguage("my");
    } else {
      i18next.changeLanguage("en-US");
    }
  };

  const translatedLanguages = (languages) => {
    let translatedLangCount = 0;
    for (const language in languages) {
      if (languages[language] === true) {
        translatedLangCount++;
      }
    }
    return translatedLangCount;
  };

  return (
    <>
      {survey?.[surveyId]?.surveyExists &&
        // welcomeDone === false &&
        (((survey[surveyId].isMultilingual && 
           survey[surveyId].status === "published") && 
           translatedLanguages(
            survey?.[surveyId]?.thirdPartySettings.languages
          ) <= 1) ||
        (greetings !== null &&
        (!survey[surveyId].isMultilingual || 
          singleLangPreview ||
          translatedLanguages(
            survey?.[surveyId]?.thirdPartySettings.languages
          ) <= 1))) && (
          <Welcome
            currentTheme={currentTheme}
            currentLang={currentLang || selectedLanguage}
            welcomeDone={() => setWelcomeDone(true)}
            thirdPartySettings={survey[surveyId].thirdPartySettings}
          />
        )}

      {survey?.[surveyId]?.surveyExists &&
        // welcomeDone === false &&
        // !singleLangPreview &&
        // survey[surveyId].isMultilingual &&
        translatedLanguages(survey?.[surveyId]?.thirdPartySettings.languages) >
          1 && (
          <MultilingualWelcome
            currentTheme={currentTheme}
            welcomeDone={handleGetStarted}
            value={selectedLanguage}
            handleChooseLanguage={chooseLanguage}
            thirdPartySettings={survey[surveyId].thirdPartySettings}
            isMultilingual={survey[surveyId].isMultilingual}
            reportName={survey[surveyId].name}
            currentLang={currentLang || selectedLanguage}
          />
        )}
    </>
  );
};

export default RenderGreetings;
